import AppContainer from "../../components/AppContainer";
import Footer from "../../components/Footer/Footer";
import { localLegalInfo } from "../../components/utils/local.policy";
import { getStore } from "../../services/backend/serverSideProps";

export async function getServerSideProps(context) {
  return getStore(context);
}

const Policy = (props) => {
  const { storeData, themeData } = props;
  const storeName = storeData.storeName;

  let policy = storeData?.legalInfo?.policy || localLegalInfo.policy || "";
  policy = policy
    .replace(/{{shop name}}/g, storeName)
    .replace(/{{subdomain}}/g, storeData.subdomain);

  return (
    <AppContainer>
      <main>
        <h2 className="sidepage-title">Policy</h2>

        {/* content */}
        {policy.trim() !== "" ? (
          <div className="sidepage-content" dangerouslySetInnerHTML={{ __html: policy }} />
        ) : null}
      </main>

      <Footer theme={themeData} />
    </AppContainer>
  );
};

export default Policy;
